import { useMemo } from "react";
import KSData from "../KS.json";
import CountdownTimer from "./CountdownTimer";
import Datetime from "./Datetime";
import { Typography } from "@material-tailwind/react";

const TABLE_HEAD = [
  "Sabahu",
  "Lindja e diellit",
  "Dreka",
  "Ikindia",
  "Akshami",
  "Jacia",
];

const KohetEnamazit = () => {
  const filteredProducts = useMemo(() => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const date = today.getDate();
    return KSData.filter(
      (product) => product.Month === month && product.Date === date
    );
  }, []);
  /// Koha e Sabahut
  const calculateSabahu = (imsaku) => {
    const [hours, minutes] = imsaku.split(":");
    const imsakuTime = new Date();
    imsakuTime.setHours(hours);
    imsakuTime.setMinutes(minutes);
    imsakuTime.setMinutes(imsakuTime.getMinutes() + 30);

    const sabahuHours = imsakuTime.getHours().toString().padStart(2, "0");
    const sabahuMinutes = imsakuTime.getMinutes().toString().padStart(2, "0");

    return `${sabahuHours}:${sabahuMinutes}`;

  };

  return (
    <div className="bg-blue-gray-800 pb-10">
      <figure className="relative gap-4 flex flex-col items-center justify-center w-full bg-blue-gray-800 pb-10 pt-10">
        <figcaption className="h-min w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4 text-center">
          <Typography variant="h3" color="white">
            Kohët e namazit për Kosovë
          </Typography>
        </figcaption>
        <figcaption className="w-[calc(100%-2rem)] max-w-[350px] mx-auto h-min rounded-xl border border-white bg-white/75 mb-4 py-4 px-3 sm:px-4">
          <div className="text-center mb-3">
            <Datetime hideTime />
          </div>
          <div>
            <Typography variant="h4" color="blue-gray">
              <CountdownTimer />
            </Typography>
          </div>
        </figcaption>
        {filteredProducts.map((product) => (
          <figcaption key={`${product.Month}-${product.Date}`} className="w-[calc(100%-2rem)] max-w-[350px] mx-auto">
            <div className="flex flex-col gap-8 mt-2 border border-blue-gray-200 bg-white/75 rounded-xl p-3 sm:p-4">
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/sabahu.png" alt="Sabahu" width={30} height={30}></img>
                  </div>
                  <div>
                    <Typography
                      variant="lead"
                      color="black"
                      className="font-semibold leading-none opacity-70" >{TABLE_HEAD[0]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{calculateSabahu(product.Imsaku)}</Typography>
                </div>
              </div>
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/sunrise.png" alt="Lindja e diellit" width={30} height={30}></img>
                  </div>
                  <div>
                    <Typography
                      variant="lead"
                      color="black"
                      className="font-semibold leading-none opacity-70">{TABLE_HEAD[1]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{product["Lindja e diellit"]}</Typography>
                </div>
              </div>
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/dreka.png" alt="Dreka" width={30} height={30}></img>
                  </div>
                  <div><Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{TABLE_HEAD[2]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{product.Dreka}</Typography>
                </div>
              </div>
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/ikindia.png" alt="Ikindia" width={30} height={30}></img>
                  </div>
                  <div>
                    <Typography
                      variant="lead"
                      color="black"
                      className="font-semibold leading-none opacity-70">{TABLE_HEAD[3]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{product.Ikindia}</Typography>
                </div>
              </div>
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/sunset.png" alt="Akshami" width={30} height={30}></img>
                  </div>
                  <div>
                    <Typography
                      variant="lead"
                      color="black"
                      className="font-semibold leading-none opacity-70">{TABLE_HEAD[4]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{product.Akshami}</Typography>
                </div>
              </div>
              <div className="flex justify-between items-center border-b-[1.5px] border-dashed  border-blue-gray-400 ">
                <div className="flex justify-between items-center gap-4">
                  <div>
                    <img src="iconsTakvim/jacia.png" alt="Jacia" width={30} height={30}></img>
                  </div>
                  <div>
                    <Typography
                      variant="lead"
                      color="black"
                      className="font-semibold leading-none opacity-70">{TABLE_HEAD[5]}</Typography>
                  </div>
                </div>
                <div>
                  <Typography
                    variant="lead"
                    color="black"
                    className="font-semibold leading-none opacity-70">{product.Jacia}</Typography>
                </div>
              </div>
            </div>
          </figcaption>
        ))}
      </figure>
    </div>
  );
};

export default KohetEnamazit;
